import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "banner__container" }
const _hoisted_2 = ["id"]
const _hoisted_3 = {
  key: 0,
  class: "banner__fallback",
  href: "/cimke/video"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "banner__fallback-txt" }, "Nézd a kedvenc műsoraid rövid videóit az RTL.hu-n!", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  width: "300",
  height: "250",
  viewBox: "0 0 300 250",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("text", {
    x: "150",
    y: "125",
    "text-anchor": "middle",
    "dominant-baseline": "middle",
    "font-size": "36",
    "font-weight": "bold",
    fill: "currentColor"
  }, [
    /*#__PURE__*/_createElementVNode("tspan", {
      x: "150",
      dy: "-60"
    }, "Nézd a kedvenc"),
    /*#__PURE__*/_createElementVNode("tspan", {
      x: "150",
      dy: "40"
    }, "műsoraid"),
    /*#__PURE__*/_createElementVNode("tspan", {
      x: "150",
      dy: "40"
    }, "rövid videóit"),
    /*#__PURE__*/_createElementVNode("tspan", {
      x: "150",
      dy: "40"
    }, "az RTL.hu-n!")
  ])
], -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_widget_block = _resolveComponent("widget-block")!

  return (_ctx.zoneId || (_ctx.showPlaceholder && _ctx.zoneKey) || _ctx.minHeight)
    ? (_openBlock(), _createBlock(_component_widget_block, {
        key: 0,
        class: _normalizeClass(["banner", {
      [`banner--${_ctx.labelPosition}`]: _ctx.labelPosition,
      'banner--background': _ctx.showBackground,
      'banner--placeholder': _ctx.showPlaceholder,
      'banner--fullfilled': _ctx.isFullfilled,
      'banner--min-height': _ctx.minHeight
    }]),
        "show-divider": false,
        "show-title": false,
        style: _normalizeStyle(_ctx.minHeight ? { '--minHeight': `${_ctx.minHeight}px` } : null)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              id: _ctx.zoneId,
              class: "banner__content",
              "data-label": "hirdetés",
              ref: "banner"
            }, [
              (_ctx.showPlaceholder && _ctx.zoneKey)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" [ Banner " + _toDisplayString(_ctx.zoneKey) + " ] ", 1)
                  ], 64))
                : _createCommentVNode("", true)
            ], 8, _hoisted_2),
            (!_ctx.showPlaceholder && _ctx.minHeight && !_ctx.isFullfilled)
              ? (_openBlock(), _createElementBlock("a", _hoisted_3, _hoisted_6))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["class", "style"]))
    : _createCommentVNode("", true)
}